import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	IconButton,
	InputAdornment,
	TextField,
	RootRef
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	fieldRoot: {
		fontSize: "1rem"
	},

	addCommentField: {
		width: "100%",
		color: theme.palette.primary.darkGrey,
		borderRadius: theme.spacing(1.5),
		backgroundColor: theme.palette.primary.white,
		border: `1px solid #D9DCDD`,

		"& input": {
			padding: "12px 12px",
			fontSize: "16px"
		},
	}
}));

function AddCommentForm(props) {
	const [comments, setComments] = useState('');
	const [isFocused, setIsFocused] = useState(false);
	const [canSubmit, setCanSubmit] = useState(false);
	const field = useRef();

	const submitForm = (update) => {
		if(comments) {
			props.addCommentHandler({
				comments: comments
			});
			setComments('');
		}
	};

	const handleKeyPress = (event) => {
		if (event.charCode === 13) {
			event.preventDefault();
			submitForm();
			field.current.querySelector("input").blur();
		}
	};

	const handleClick = (event) => {
		// so other components click handlers don't fire
		event.stopPropagation();
	};

	const handleBlur = (event) => {
		setTimeout(() => {
			setIsFocused(false);
			if (props.blurHandler) {
				props.blurHandler();
			}
		}, 150);
	};

	const handleFocus = (event) => {
		setIsFocused(true);
		if (props.focusHandler) {
			props.focusHandler();
		}
	};

	const postClicked = (event) => {
		// so other components click handlers don't fire
		event.stopPropagation();
		submitForm();
	};

	/**
	 * Handles changes to any form fields & updates corresponding state. Upon submit, get form values from
	 * state to pass into addCommentHandler. Probably should also figure out consistent way to prevent exploiits
	 * as well as validate submissions before sending to backend...
	 * @param  {event} event Form control change event
	 */
	const handleChange = (event) => {
		let value = event.target.value;
		setComments(value);
		setIsFocused(true);
		setCanSubmit(value ? true : false);
	};

	let classes = styles();
	return (
		<form noValidate autoComplete="off">
			<RootRef rootRef={field}>
				<TextField
					name="comments"
					placeholder={"Add comment"}
					onClick={handleClick}
					onKeyPress={handleKeyPress}
					onChange={handleChange}
					onFocus={handleFocus}
					onBlur={handleBlur}
					value={comments}
					className={classes.addCommentField}
					margin="normal"
					InputProps={{
						disableUnderline: true,
						classes: {root: classes.fieldRoot},
						endAdornment: isFocused ? (
							<InputAdornment position="end">
								<IconButton
									onClick={postClicked}
									color="primary"
									disabled={!canSubmit}
									aria-label="Add Comment"
									tabIndex={0}>
									<FontAwesomeIcon icon={["fal", "paper-plane"]} size="xs" />
								</IconButton>
							</InputAdornment>
						) : null
					}}
				/>
			</RootRef>
		</form>
	);
}

AddCommentForm.propTypes = {
	addCommentHandler: PropTypes.func,
	focusHandler: PropTypes.func,
	blurHandler: PropTypes.func
};

export default AddCommentForm;
